import { render, staticRenderFns } from "./questionFormNode.vue?vue&type=template&id=5f44c1ea&scoped=true"
import script from "./questionFormNode.vue?vue&type=script&lang=js"
export * from "./questionFormNode.vue?vue&type=script&lang=js"
import style0 from "./questionFormNode.vue?vue&type=style&index=0&id=5f44c1ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f44c1ea",
  null
  
)

export default component.exports